import { createContext, useContext } from "react";
import * as filestack from "filestack-js";
import { FileSecurity } from "../types/file";

export interface FileStackContextValue {
  filestack: filestack.Client | null;
  security: FileSecurity | undefined;
  getFileStackUrl: (fileStackHandle: string, options?: filestack.TransformOptions) => string | null;
}

export const FileStackContext = createContext<FileStackContextValue>({
  filestack: null,
  security: undefined,
  getFileStackUrl: () => null,
});

export function useFileStackContext(): FileStackContextValue {
  const context = useContext(FileStackContext);
  if (!context) throw new Error("FileStackContext must be initialized.");
  return context;
}
